import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, DataListItem, InfoCard } from '@node-space/ui-components'
import { SheetStatusCard } from 'components/SheetStatusCard/SheetStatusCard'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { paymentLinkUrlAtom } from './atoms/atoms'

export const PaymentLinkComplete = () => {
  const { t } = useTranslation()
  const [walletAction] = useContext(WalletActionContext)
  const paymentLinkUrl = useAtomValue(paymentLinkUrlAtom)
  const contact = useAtomValue(contactAtom)

  const selfOwned = contact.relationshipType === 'SELF_OWNED'

  return (
    <SheetStatusCard
      testid="payment-link-complete"
      headline={t('payments.paymentLinks.paymentRequestCreated')}
      status="success"
      ActionButtons={[
        <Button
          key="back-to-channel-payments"
          data-testid="back-to-channel-payments"
          onClick={() => {
            walletAction?.onClose()
            walletAction?.meta?.onPaymentChannelSuccess?.()
          }}
        >
          {t('done')}
        </Button>,
        ...(selfOwned
          ? [
              <Button
                key="open-payment-link"
                data-testid="open-payment-link"
                onClick={() => window.open(paymentLinkUrl, '_blank', 'noopener,noreferrer')}
              >
                {t('openPaymentLink')}
              </Button>,
            ]
          : []),
      ]}
    >
      <Box className="text-center" flexCol width="full" gapY={16}>
        <InfoCard>
          <DataListItem
            id="payment-link-url"
            layout="vertical"
            title={t('payments.paymentLinks.paymentLinkUrl')}
            body={`${paymentLinkUrl.slice(0, 50)}...`}
            copyText={paymentLinkUrl}
          />
        </InfoCard>
        <Box tag="p" className="text-body-regular text-foreground-subdued text-center">
          {selfOwned
            ? t('payments.paymentLinks.paymentLinkCompleteDescriptionSelfOwned')
            : t('payments.paymentLinks.paymentLinkCompleteDescription', {
                contactName: contact?.name,
              })}
        </Box>
      </Box>
    </SheetStatusCard>
  )
}
